import React from 'react';

interface InputProps {
  value: string;
  type: string;
  changeValue?: (value: string) => void;
  label?: string;
  placeholder: string;
  readOnly?: boolean;
  className?: string;
}

const Input: React.FC<InputProps> = ({
  value,
  type,
  changeValue,
  label,
  placeholder,
  readOnly = false,
  className = '',
}) => {
  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label
          className="block mb-2 text-sm font-medium"
          style={{ color: 'var(--text-primary)' }}
        >
          {label}
        </label>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={changeValue ? (e) => changeValue(e.target.value) : undefined}
        readOnly={readOnly}
        className={`
          w-full px-4 py-3 rounded-lg
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-offset-2
          ${readOnly ? 'cursor-default' : ''}
        `}
        required={!readOnly}
        min="0"
        style={{
          background: 'var(--input-bg)',
          border: '1px solid var(--input-border)',
          color: 'var(--input-color)',
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
        }}
      />
    </div>
  );
};

export default Input;
